<template>
  <div class="diadin">



    <el-form :inline="true" :model="formInline" class="demo-form-inline">


      <el-form-item>
        <el-input style="width: 300px" :placeholder="$t('menu.FrameNumber')" v-model="formInline.title"></el-input>
      </el-form-item>



      <el-form-item>
        <el-button type="primary" @click="getLista()">{{ $t('menu.search') }}</el-button>
      </el-form-item>


      <div style="width: 100%;height: 1px; background-color: #eee;margin-bottom: 30px;"></div>

    </el-form>
    <div class="box" style="display: flex;height: 900px;" v-if="pcc == false">
      <div class="leftbox">
        <el-tabs v-model="actionn">
          <el-tab-pane :label="inle == 'zh' ? '整车' : 'Vehicle'" name="F"></el-tab-pane>
          <el-tab-pane :label="inle == 'zh' ? '发动机' : 'Engine'" name="E"></el-tab-pane>

        </el-tabs>
        <!-- <div class="chexing">{{ seriesModel }}</div>
        <div class="fg"></div> -->
        <!-- <div>
          <div v-for="(item, index) in mation" :key="index" style="padding-left: 20px;"
            v-if="item.visible == true && inle == 'zh' && actionn == item.categoryCode.slice(0, 1)">
      
            <div class="big-pj" :class="categoryName == item.categoryName ? 'acta' : ''"
              @click="onsubtitle(item.id, item.categoryName)">
              {{ item.categoryCode + '-' }} {{ inle == 'zh' ? item.categoryName : item.categoryNameEn }}
            </div>
          </div>
          <div v-for="(item, index) in mation" :key="index" style="padding-left: 20px;"
            v-if="item.visible == true && inle !== 'zh' && actionn == item.categoryCode.slice(0, 1)">
        
            <div class="big-pj" :class="categoryName == item.categoryNameEn ? 'acta' : ''"
              @click="onsubtitle(item.id, item.categoryNameEn)">
              {{ item.categoryCode + '-' }} {{ inle == 'zh' ? item.categoryName : item.categoryNameEn }}
            </div>
          </div>
        </div> -->


        <div style="overflow-x: auto;">
          <!-- <div > -->
          <!-- <el-tooltip class="item" effect="dark"
              :content="item.categoryCode + '-' + inle == 'zh' ? item.categoryName : item.categoryNameEn"
              placement="top">

            </el-tooltip> -->
          <div v-for="(item, index) in mation" :key="index" style="padding-left: 20px;"
            v-if="item.visible == true && inle == 'zh' && actionn == item.categoryCode.slice(0, 1)" class="big-pj"
            :class="categoryName == item.categoryName ? 'acta' : ''" @click="onsubtitle(item.id, item.categoryName)">
            {{ item.categoryCode + '-' }} {{  sxtitle(item)  }}
          </div>
          <!-- </div> -->
          <!-- <div > -->
          <!-- <el-tooltip class="item" effect="dark"
              :content="item.categoryCode + '-' + inle == 'zh' ? item.categoryName : item.categoryNameEn"
              placement="top">

            </el-tooltip> -->
          <div v-for="(item, index) in mation" :key="index" style="padding-left: 20px;"
            v-if="item.visible == true && inle !== 'zh' && actionn == item.categoryCode.slice(0, 1)" class="big-pj"
            :class="categoryName == item.categoryNameEn ? 'acta' : ''"
            @click="onsubtitle(item.id, item.categoryNameEn)">
            {{ item.categoryCode + '-' }} {{sxtitle(item) }}
          </div>
          <!-- </div> -->
        </div>


      </div>

      <div class="center-box" style="width: 80%;height: 80%;">
        <div class="block" style="width: 100%;height: 100%;">
          <el-image :src="urlItem">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>

        <div style="display: flex; justify-content: center;">
          <img v-for="item in urlList" :src="item" :class="item == urlItem ? 'acttimg' : ''" class="img-item"
            @click="setImgUrl(item)">
        </div>
      </div>



      <div class="rightbox">
        <div class="chexing">{{ sxtitlea(categoryName)}}</div>
        <div class="fg"></div>
        <div class="infinite-list-wrapper" style="
            overflow: auto;
            height: 100%;
            width: 100%;
          ">
          <div v-for="(item, index) in mation1" :key="index" class="list-item">
            <div class="right-item" style="width: 100%;height: 100%;">
              <div class="left">
                <template>
                  <!-- <el-image v-if="item.detailImageList" style="width: 150px; height: 120px" :src="url"
                      :preview-src-list="item.detailImageList">
                    </el-image>
                    <el-image v-else style="width: 150px; height: 120px" :src="url">
                    </el-image> -->
                </template>
                <div class="product-info">
                  <div class="name-info">
                    <div class="name-info-1">
                      <div class="index">{{ item.diagramNum }}</div>
                      <p style="color: #222222;font-weight: 550;display: flex;  word-wrap:break-word; 
word-break:break-all; 
overflow: hidden;  flex-wrap: nowrap;text-decoration: underline;cursor: pointer;" @click="openDetails(item)">{{
  inle == 'zh' ? item.partName : item.partNameEn
                        }}</p>

                    </div>

                    <p>{{ item.partNumber }}</p>
                    <p style="margin-bottom: 10px;" v-if="item.relationList.length > 0">{{ $t('menu.Alternative')
                      }}：<span v-for="(e, i) in item.relationList" :key="i">{{
                        e.part.partNumber
                      }} <span v-if="i < item.relationList.length - 1">、</span> </span></p>
                    <!-- <div class="details">{{item.createdTime}},单元用量：2 莫得灵黑</div> -->
                  </div>
                </div>



                <div class="num-box1">
                  <el-input-number v-model="item.buyNum" :min="item.minPurchaseQuantity" size="mini"
                    @change="changeNum($event, item.minPurchaseQuantity, index,)"></el-input-number>
                  <!-- <p v-if="item.show" style="color: red;">最小采购量：{{ item.minPurchaseQuantity }}</p> -->
                </div>
              
                 <div v-if="tup==2&&item.partRetailer!==null" style="display: flex;">
                      <div class="kcbox" :style="item.partRetailer.currentStock>item.partRetailer.safetyStock?{backgroundColor:'#9df29f'}:{}"></div>
                      <div class="kcbox" :style="item.partRetailer.safetyStock>item.partRetailer.currentStock&&item.partRetailer.currentStock>0?{backgroundColor:'#f9d106'}:{}"></div>
                     
                   <div class="kcbox" :style="item.partRetailer.currentStock==0?{backgroundColor:'#f91c16'}:{}"></div>
                    </div>
              </div>
                <div v-if="pict==0">
                 <div class="price" v-if="bz == 'CNY'&&  item.purchasePriceCny!=='0'&&  item.purchasePriceCny!==null" :class="active != 2 ? 'max-width' : ''">￥{{
                item.purchasePriceCny }} <span class="pricea">{{ pjst(item.unit) }}</span> </div>
              <div class="price" v-if="bz == 'USD'&&  item.purchasePriceUsd!==0&&  item.purchasePriceUsd!==null" :class="active != 2 ? 'max-width' : ''">${{
                item.purchasePriceUsd }} <span class="pricea">{{ pjst(item.unit) }}</span> </div>
              <div class="price" v-if="bz == 'EUR'&&  item.purchasePriceEur!==0&&  item.purchasePriceEur!==null" :class="active != 2 ? 'max-width' : ''">€{{
                item.purchasePriceEur }} <span class="pricea">{{ pjst(item.unit) }}</span> </div>
              </div>
               <div v-else>
                 <div class="price" v-if="bz == 'CNY'&&  item.purchasePriceCny!=='0'&&  item.purchasePriceCny!==null" :class="active != 2 ? 'max-width' : ''">￥{{
                numFilter(item.purchasePriceCny/0.65) }} <span class="pricea">{{ pjst(item.unit) }}</span> </div>
              <div class="price" v-if="bz == 'USD'&&  item.purchasePriceUsd!==0&&  item.purchasePriceUsd!==null" :class="active != 2 ? 'max-width' : ''">${{
                numFilter(item.purchasePriceUsd/0.65) }} <span class="pricea">{{ pjst(item.unit) }}</span> </div>
              <div class="price" v-if="bz == 'EUR'&&  item.purchasePriceEur!==0&&  item.purchasePriceEur!==null" :class="active != 2 ? 'max-width' : ''">€{{
                numFilter(item.purchasePriceEur/0.65) }} <span class="pricea">{{ pjst(item.unit) }}</span> </div>
               </div>
              <!-- <div class="price" v-if="bz == 'CNY'&&  item.purchasePriceCny!==0&&  item.purchasePriceCny!==null" :class="active != 2 ? 'max-width' : ''">￥{{
                item.purchasePriceCny }} <span class="pricea">{{ pjst(item.unit) }}</span> </div>
              <div class="price" v-if="bz == 'USD'&&  item.purchasePriceUsd!==0&&  item.purchasePriceUsd!==null" :class="active != 2 ? 'max-width' : ''">${{
                item.purchasePriceUsd }} <span class="pricea">{{ pjst(item.unit) }}</span> </div>
              <div class="price" v-if="bz == 'EUR'&&  item.purchasePriceEur!==0&&  item.purchasePriceEur!==null" :class="active != 2 ? 'max-width' : ''">€{{
                item.purchasePriceEur }} <span class="pricea">{{ pjst(item.unit) }}</span> </div> -->
                <!-- <div class="price" v-if="item.purchasePriceCny=='0'||item.purchasePriceCny==null|| item.purchasePriceUsd=='0'||item.purchasePriceUsd==null|| item.purchasePriceEur=='0'||item.purchasePriceEur==null" :class="active != 2 ? 'max-width' : ''">N.A</div> -->
              <div class="right" style="display: flex;flex: 1;align-items: center;min-width: 30%;">


                <div class="btn-box">
                     <el-button type="primary" v-if="item.status == true&&tup=='2'&&item.partRetailer!==null" class="btn buy"
                    :disabled="item.partRetailer.status!==1"
                    :class="[item.btnType == true || item.status == false||item.partRetailer.status!==1 ? 'hui' : '']" @click="buyCart(item, index)">
                    <div style="display: flex; align-items: center; justify-content: center;"><img class="ico"
                        src="../../assets/images/PC20240924-103854.png" alt="">
                      <div class="jyyy">{{ item.btnType == true || item.status
                        ==
                        false ? $t('menu.Add') : $t('menu.Add') }}</div>
                    </div> 
                  </el-button>
                  <el-button type="primary" v-if="item.status == true&&tup=='2'&&item.partRetailer==null" class="btn buy hui"
                    disabled
                     @click="buyCart(item, index)">
                    <div style="display: flex; align-items: center; justify-content: center;"><img class="ico"
                        src="../../assets/images/PC20240924-103854.png" alt="">
                      <div class="jyyy">{{ item.btnType == true || item.status
                        ==
                        false ? $t('menu.Add') : $t('menu.Add') }}</div>
                    </div> 
                  </el-button>




                  <el-button type="primary" v-if="item.status == true&&tup!=='2'" class="btn buy"
                    :disabled="item.btnType == true || item.status == false"
                    :class="[item.btnType == true || item.status == false ? 'hui' : '']" @click="buyCart(item, index)">
                    <div style="display: flex; align-items: center; justify-content: center;"><img class="ico"
                        src="../../assets/images/PC20240924-103854.png" alt="">
                      <div class="jyyy">{{ item.btnType == true || item.status
                        ==
                        false ? $t('menu.Add') : $t('menu.Add') }}</div>
                    </div>
                  </el-button>
                  <el-button type="primary" v-if="item.status == false" class="btn buy"
                    :disabled="item.btnType == true || item.status == false"
                    :class="[item.btnType == true || item.status == false ? 'hui' : '']" @click="buyCart(item, index)">
                    <div style="display: flex; align-items: center; justify-content: center;">
                      <!-- <img class="ico"
                        src="../../assets/images/PC20240924-103854.png" alt=""> -->
                      <div class="jyyy">{{ item.btnType == true || item.status
                        ==
                        false ? $t('menu.Soldout') : $t('menu.Add') }}</div>
                    </div>
                  </el-button>
                  <!-- <div class="btn end">已停供</div> -->
                </div>
              </div>
            </div>
          </div>



        </div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="page"
          :page-size="10" layout="total, prev, pager, next" :total="totale">
        </el-pagination>
      </div>
    </div>
    <div class="box" style="display: flex;height: 900px;" v-if="pcc == true">
      {{ $t('menu.NoVehiclePartsInformationFound') }}
    </div>
    <div class="box" style="display: flex;height: 900px;" v-if="mation.length < 0">
      未查询到对应车辆

    </div>

    <el-dialog :title="inle == 'zh' ? detailsObj.partName : detailsObj.partNameEn" :visible.sync="detailsFlag"
      width="30%">
      <div class="details-box">
        <div class="text-box">
          <div>
            {{ $t('menu.unit') }}:{{ detailsObj.defaultPerVehicleUsage }}
          </div>
          <div v-if="detailsObj.effectiveDate !== undefined">
            {{ $t('menu.Effectivedate') }}:{{ detailsObj.effectiveDate.slice(0, 10) }}
          </div>
          <div v-else>
            {{ $t('menu.Effectivedate') }}:{{ detailsObj.effectiveDate }}
          </div>

          <div>
            {{ $t('menu.MinimumPurchaseQuantity') }}:{{ detailsObj.minPurchaseQuantity }}
          </div>
        </div>

        <div class="shuoming">
          {{ detailsObj.remarks }}
        </div>


        <div class="img-box-details">
          <el-image class="elimg" v-for="item in detailsImgList" :src="item" alt=""
            :preview-src-list="detailsImgList"></el-image>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import attachments from './attachments'
// import attachment from './attachment'
// import cart from './cart'
import {
  addCart,
  listMcSeriesModels,
  pageQueryPart,
  pageQueryPartCategory,
  pageQueryParta,
  querytype,
  mcVehicleOfDealerLista,
  pageQueryParta1
} from "../../api/api";

export default {
  // components: {
  //   attachment,
  //   attachments,
  //   cart,
  // },
  data () {
    return {
      active: 1,
      actionn:'F',
      list: [],
      mation: [],
      mation1: [],
      loading: false,
      mcSeriesModelId: '',
      seriesModel: "",
      categoryId: "",
      categoryName: "",
      page: 1,
      totale: 0,
      url: '',
      show: false,
      formInline: {
        title: "",
        status: "",
        startTime: "",
        endTime: "",
        contact: "",
        category: "",
        type: "",
      },
      urlList: [],
      urlItem: '',
      pcc: true,
      prList: [],
      bz: 'CNY',
      detailsFlag: false,
      detailsObj: {},
      detailsImgList: [],
      inle: 'zh',
      tup:1,
      pict:0,
    };
  },
  created () {
     this.tup = sessionStorage.getItem('platform')
    let a = sessionStorage.getItem('i18n')
    this.inle = a
     this.pict=sessionStorage.getItem('picaetype')||0
    this.listMcSeriesModel();
    // this.biao();
    this.jg()
    this.bz = sessionStorage.getItem('shbz')
  },
  computed: {
    noMore () {
      return this.page >= this.totale;
    },
    disabled () {
      return this.loading || this.noMore;
    },
  },
  watch: {
    mation1: {
      handler (newVal, oldVal) {
        // console.log(oldVal)
        // console.log(newVal)
      },
      deep: true
    }
  },
  methods: {
       sxtitlea(e){
      let a =''
  
        
      if(this.inle=='zh'){
        a=e
      }
    if(this.inle=='en'){
      if(e.indexOf(":") !== -1){
       
        let c =JSON.parse(e)
     
        a=c.en
      }else{
        a=e
      }
      

      }
      if(this.inle=='de'){
         if(e.indexOf(":") !== -1){
             let d =JSON.parse(e)
        a=d.de
         } else{
        a=e
      } 
         
      
      }
      return a

    },
     sxtitle(e){
      let a =''
        // console.log(11,JSON.parse(e.categoryNameEn));
        
      if(this.inle=='zh'){
        a=e.categoryName
      }
    if(this.inle=='en'){
      if(e.categoryNameEn.indexOf(":") !== -1){
       
        let c =JSON.parse(e.categoryNameEn)
     
        a=c.en
      }else{
        a=e.categoryNameEn
      }
      

      }
      if(this.inle=='de'){
         if(e.categoryNameEn.indexOf(":") !== -1){
             let d =JSON.parse(e.categoryNameEn)
        a=d.de
         } else{
        a=e.categoryNameEn
      } 
         
      
      }
      return a

    },
      numFilter (value) {
          let realVal = ''
        if(value!==undefined&&value!==null&&value!==''){
         realVal = Number(value).toFixed(2)
        }
    // 截取当前数据到小数点后两位
  
    return realVal
  },
    openDetails (item) {
      console.log(item)
      this.detailsImgList = []
      this.detailsObj = item
      if (this.detailsObj.detailImageList !== null) {
        this.detailsImgList = this.detailsObj.detailImageList.split(',')
      }
      this.detailsFlag = true
    },
    jg () {
      let param = new URLSearchParams();
      querytype(param, 't_part_unit').then(r => {
        if (r.data.code == 200) {
          this.prList = r.data.data
        }
      })
    },
    pjst (e) {
      let a = this.prList
      let b = ''
      a.forEach(z => {
        if (e == z.dictValue && this.inle == 'zh') {
          b = z.dictLabel
        }
        if (e == z.dictValue && this.inle !== 'zh') {
          b = z.dictLabelEn
        }
      })
      return '/' + b
    },
    changeNum (e, min, index) {
      console.log(e, index)
      if (e == min) {
        this.mation1[index].show = true
      }
      setTimeout(() => {
        this.mation1[index].show = false

      }, 5000);
      this.$forceUpdate()
    },
    setActive (num) {
      this.active = num
    },
    setImgUrl (url) {
      this.urlItem = url
    },
    buyCart (item, index) {
      this.mation1[index].btnType = true
          let a =1
      if(item.mcSeriesModel.mcCategory.dictValue!=="Motorcycle"){
        a=3
      }
      this.$forceUpdate()
      let param = new URLSearchParams();
      addCart(
        param,
        item.id,
        item.buyNum,
        a
      ).then(r => {
        console.log(r)
        if (r.data.code == 200) {
          this.$message.success(this.$t('menu.SUCESS'))
          setTimeout(() => {
            this.mation1[index].btnType = false
            this.$forceUpdate()
          }, 1000);
        } else {
          setTimeout(() => {
            this.mation1[index].btnType = false
            this.$forceUpdate()
          }, 1000);
        }
      })

    },

    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.page = val
      this.pageQueryParts();
      console.log(`当前页: ${val}`);
    },
    async biao () {
      let param = new URLSearchParams();
      let mcSeriesModelId = this.mcSeriesModelId;
      let searchKey = '';
      const { data: res } = await pageQueryPartCategory(
        param,
        1,
        100,
        mcSeriesModelId,
        searchKey
      );
      this.mation = res.data.list
      if (res.data.total > 0) {
        this.pcc = false
        if (this.inle == 'zh') {
          this.categoryName = this.mation[0].categoryName;
        } else {
          this.categoryName = this.mation[0].categoryNameEn;
        }
        this.categoryId = this.mation[0].id;
        console.log(1);

        this.page = 1
        // this.mcSeriesModelId=this.mation[0].mcSeriesModelId
        this.seriesModel = this.mation[0].mcSeriesModel.seriesModel;
        this.onsubtitle(this.categoryId, this.categoryName);
      } else {
        this.pcc = true
      }

    },
    //获取车型
    async listMcSeriesModel () {
      let param = new URLSearchParams();

      const { data: res } = await listMcSeriesModels(param);

      this.list = res.data;
      this.formInline.category = this.mcSeriesModelId
      if (this.inle == 'zh') {
        this.seriesModel = this.list[1].seriesModel;
      } else {
        this.seriesModel = this.list[1].seriesModelEn;
      }
    },
    //配件查询
    async pageQueryParts () {
      let param = new URLSearchParams();
      console.log(this.categoryId);

      let mcSeriesModelId = this.mcSeriesModelId;
      let searchKey = '';
      let categoryId = this.categoryId;
      const { data: res } = await pageQueryPart(
        param,
        this.page,
        10,
        mcSeriesModelId,
        searchKey,
        this.categoryId
      );

      this.mation1 = res.data.list
 res.data.list.forEach((e, i) => {
        this.mation1[i].buyNum = e.minPurchaseQuantity

      });

      this.totale = res.data.total;
    },
    async onsubtitle (e, i) {
      this.categoryId = e
      this.page = 1
      let param = new URLSearchParams();
      let mcSeriesModelId = this.mcSeriesModelId;
      let searchKey = '';
      let categoryId = e;
      const { data: res } = await pageQueryPart(
        param,
        this.page,
        10,
        mcSeriesModelId,
        searchKey,
        categoryId
      );
      this.mation1 = res.data.list
      res.data.list.forEach((e, i) => {
        this.mation1[i].buyNum = e.minPurchaseQuantity

      });
      if (this.mation1.length > 0) {
     
          this.urlList = this.mation1[0].partCategory.diagramImageList.split(',')
       
        this.seriesModel = this.mation1[0].mcSeriesModel.seriesModel;
      }
      console.log(this.urlList);
      
        if (this.urlList) {
     
          this.urlItem = this.urlList[0]
      }
     
      this.totale = res.data.total;
      this.categoryName = i

    },
    load () {
      this.loading = true;
      if (this.mation1 >= this.totale == false) {
        setTimeout(() => {
          this.page++;
          this.pageQueryParts();
          this.loading = false;
        }, 2000);
      }
    },
    //查询车辆列表
    getLista () {

      let params = 'searchValue=' + this.formInline.title
      mcVehicleOfDealerLista(params).then(res => {
        if (res.data.total !== 0) {
          console.log(2, res.data.rows[0]);
          console.log(2, res);

          this.onSubmit(res.data.rows[0].mcSeriesModel)
          this.actionn = 'F'

        } else {
          this.$message.error(this.$t('menu.NoVehiclePartsInformationFound'));
        }
      })

    },
    //搜索
    async onSubmit (num) {


      console.log(1111111111, num);

      this.page = 1
      let param = new URLSearchParams();
      let mcSeriesModelId = num
      let searchKey = ''

      const { data: res } = await pageQueryParta1(
        param,
        this.page,
        100,
        mcSeriesModelId,
        searchKey
      );
      this.mation = res.data.list;
      if (res.data.total > 0) {
        this.pcc = false
        if (this.inle == 'zh') {
          this.categoryName = this.mation[0].categoryName;
        } else {
          this.categoryName = this.mation[0].categoryNameEn;
        }

        this.categoryId = this.mation[0].id;
        console.log(1);
        this.seriesModel = this.mation[0].mcSeriesModel.seriesModel;
        this.page = 1
        // this.mcSeriesModelId=this.mation[0].mcSeriesModelId
        this.onsubtitle(this.categoryId, this.categoryName);
      } else {
        this.pcc = true
        this.$message.error(this.$t('menu.NoVehiclePartsInformationFound'));
      }



    },
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.list-item {
  width: 100%;
  height: 180px;
}

.list-item:hover {
  background-color: #40a0ff27;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}
.kcbox{
 width: 16px;
  height: 16px;
  border-radius: 100px;
  background-color: #dbdbdb;
  margin-right: 10px;
  margin-top: 10px;
}
.fg {
  border-bottom: 1px solid #f2f2f2;
  width: 100%;
  margin-bottom: 10px;
}

.name-info1 {
  display: flex;
  height: 40px;
  align-items: center;

  .partName {
    color: #222222;
    font-weight: 550;
    min-width: 200px;
  }
}

.name-info-1 {
  display: flex;
  justify-content: flex-start;
}

.ico {
  width: 20px;
  height: 20px;
}

.right-item1 {
  width: 100%;
  display: flex;
  margin-top: 10px;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;

  .price {
    color: red;
    margin-left: 50px;
    display: flex;
    align-items: center;
  }
}

.price {
  color: red;
  margin-left: 50px;
  display: flex;
  font-size: 18px;
  font-weight: 600;
  align-items: center;
}

.pricea {
  font-size: 14px;
  font-weight: 400;
  display: inline-block;
  color: #999999;
}

.left {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  width: 30%;
  padding-left: 20px;
}

.chexing {
  height: 30px;
  display: flex;
  align-items: center;
  border-left: 4px solid #409eff;
  padding-left: 20px;
  // margin-bottom: 10px;
}

.qqq {
  margin-left: 80px;
  min-width: 30%;
}

.acta {
  background-color: #beebff;
}

.img-item {
  width: 100px;
  height: 80px;
  cursor: pointer;
  border: 1px solid #eeeeee;
  margin-right: 20px;
}

.acttimg {
  border: 3px solid #409eff;
}

.leftbox {
  width: 28%;
  overflow-y: scroll;
  overflow-x: auto;

  .big-pj {
    height: 40px;
    cursor: pointer;
    line-height: 40px;
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
  }
}

.rightbox {
  flex: 1;
  padding-left: 20px;
  padding: 0 0 40px 0;
  height: 100%;
  min-width: 28vw;
  border: 1px solid #eee;
}

.right-item {
  width: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;

  .price {
    color: red;
    margin-left: 50px;
    display: flex;
    align-items: center;
  }
}

.product-info1 {
  margin-left: 20px;
  display: flex;
  color: #999999;

  .name-info1 {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

    p {
      margin-bottom: 10px;
    }
  }

}

.product-info {
  // margin-left: 20px;
  width: 300px;
  display: flex;
  justify-content: flex-start;
  color: #999999;

  .name-info {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

    p {
      // margin-bottom: 10px;
    }
  }

}

.right {
  justify-content: flex-end;
  margin-right: 40px;
  // margin-left: 40px;
}
/deep/.el-tabs{
  height: auto !important;
}
.index1 {
  margin-left: 10px;
  min-width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #409eff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.num-box1 {
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.num-box {
  // height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin-top: 70px;

  p {
    // margin-top: 10px;
  }
}

.active {
  color: #409eff;
}

.max-width {
  margin-left: 45px !important;
  // width: 40% !important;
}

.btn-box1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 300px;

  .btn {
    width: 120px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
  }

  .buy {
    background-color: #409eff;
  }

  .end {
    background-color: #d7d7d7;
  }
}

.btn-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 30px;

  .btn {
    width: 120px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
  }

  .buy {
    background-color: #409eff;
  }

  .end {
    background-color: #d7d7d7;
  }
}

.center-box {
  width: 1700px;
}

/deep/ .el-image {
  width: 100%;
  height: 80%;
}

/deep/.el-input-number {
  width: 130px;
}

/deep/.el-dialog__header {
  padding-right: 80px;
}

/deep/.el-dialog__title {
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  margin-right: 20px;
}

.line {
  width: 100%;
  height: 2px;
  background-color: #409eff;
  margin-top: 8px;
}

.jyyy {
  font-size: 16px;
  padding-left: 8px;
}

.index {
  min-width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #409eff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tabs {
  display: flex;

  div {
    margin-right: 15px;
    cursor: pointer;

  }
}

.hui {
  background-color: #d7d7d7 !important;
  border: none !important;
}

.jyyy {
  font-size: 16px;
  padding-left: 8px;
}

.text-box {
  display: flex;
  flex-wrap: wrap;

  div {
    width: 50%;
    margin-bottom: 20px;
  }
}

.shuoming {
  margin-top: 30px;
}

.img-box-details {
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .elimg {
    width: 200px;
    height: 200px;
    margin-right: 10px;
  }
}

.details-box {
  padding: 20px 0px;
  padding-top: 0;
}

.text-box {
  display: flex;
  flex-wrap: wrap;

  div {
    width: 50%;
    margin-bottom: 20px;
  }
}
</style>